import React, { useEffect } from "react";
import CustomInput from "common/components/CustomInput/CustomInput.jsx";

const EasyOpenInput = (props) => {
  const { propName } = props;
  const setPropMounted = props.connectForm.setPropMounted;

  useEffect(() => {
    setPropMounted(propName, true);
    return () => {
      setPropMounted(propName, false);
    };
  }, [setPropMounted, propName]);

  const spreadIt = props.inputProps == null ? {} : props.inputProps;
  return (
    <CustomInput
      success={props.connectForm.getState(propName) === "Success"}
      error={props.connectForm.getState(propName) === "Error"}
      labelText={
        <span>
          {props.connectForm.getLabel(propName) + " "}
          {props.connectForm.isRequired(propName) ? (
            <span style={{ color: "red" }}>*</span>
          ) : (
            ""
          )}
        </span>
      }
      id={propName}
      formControlProps={{
        fullWidth: true,
      }}
      inputProps={{
        onChange: (event) =>
          props.connectForm.change(event.target.value, propName),
        value: props.connectForm.getValue(propName),
        autoComplete: "off",
        ...spreadIt,
      }}
    />
  );
};

export default EasyOpenInput;
